import React from 'react';

type BadgeVariant =
  | 'active' | 'paused' | 'draft' | 'review' | 'completed' | 'failed'
  | 'facebook'| 'instagram' | 'admin' | 'manager' | 'editor' |'scheduled' | 'published' | 'publishing';

interface BadgeProps {
  variant: BadgeVariant;
  children: React.ReactNode;
  dot?: boolean;
}

const variantMap: Record<BadgeVariant, string> = {
  active: 'badge-active',
  paused: 'badge-paused',
  draft: 'badge-draft',
  review: 'badge-review',
  completed: 'badge-completed',
  failed: 'badge-failed',
  facebook: 'badge-facebook',
  instagram: 'badge-instagram',
  admin: 'badge-admin',
  manager: 'badge-manager',
  editor: 'badge-editor',
  scheduled: 'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-info/10 text-info',
  published: 'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-positive/10 text-positive',
  publishing: 'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-warning/10 text-warning',
};

export default function Badge({ variant, children, dot }: BadgeProps) {
  return (
    <span className={variantMap[variant]}>
      {dot && <span className="w-1.5 h-1.5 rounded-full bg-current opacity-80" />}
      {children}
    </span>
  );
}